package one.healthium.ui.compose.theme

import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.Immutable
import androidx.compose.ui.graphics.Shape
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp

@Immutable
class AppShapes(
    val contentGroupCornerSize: Dp,
    val small: Shape,
    val medium: Shape,
    val large: Shape,
    val button: Shape = medium,
    val sheet: Shape = RoundedCornerShape(topStart = 28.dp, topEnd = 28.dp),
)

object Shapes {
    val carni = AppShapes(
        contentGroupCornerSize = 24.dp,
        small = RoundedCornerShape(12.dp),
        medium = CircleShape,
        large = RoundedCornerShape(30.dp),
    )

    val pcos = AppShapes(
        contentGroupCornerSize = 6.dp,
        small = RoundedCornerShape(6.dp),
        medium = CircleShape,
        large = RoundedCornerShape(6.dp),
    )

    val med = AppShapes(
        contentGroupCornerSize = 6.dp,
        small = RoundedCornerShape(6.dp),
        medium = RoundedCornerShape(6.dp),
        large = RoundedCornerShape(6.dp),
    )

    val pilates = AppShapes(
        contentGroupCornerSize = 6.dp,
        small = RoundedCornerShape(6.dp),
        medium = RoundedCornerShape(6.dp),
        large = RoundedCornerShape(6.dp),
    )

    val bland = AppShapes(
        contentGroupCornerSize = 12.dp,
        small = RoundedCornerShape(12.dp),
        medium = CircleShape,
        large = RoundedCornerShape(12.dp),
    )

    val cali = AppShapes(
        contentGroupCornerSize = 6.dp,
        small = RoundedCornerShape(6.dp),
        medium = RoundedCornerShape(6.dp),
        large = RoundedCornerShape(6.dp),
        button = CircleShape,
        sheet = RoundedCornerShape(topStart = 6.dp, topEnd = 6.dp),
    )

    val life = AppShapes(
        contentGroupCornerSize = 12.dp,
        small = RoundedCornerShape(12.dp),
        medium = RoundedCornerShape(16.dp),
        large = RoundedCornerShape(30.dp),
        button = RoundedCornerShape(16.dp),
        sheet = RoundedCornerShape(topStart = 30.dp, topEnd = 30.dp),
    )
}